import React from "react";
import banner from "../../assets/banner.png";
import logo from "../../assets/logo.png";
import Error from "../../assets/error.png";
import { Link, useLocation } from "react-router-dom";

export default function LoginError() {
  const location = useLocation();
  const errorMessage = location.state?.errorMessage;
  return (
    <>
      <div className="container-fluid login-main">
        <div className="row h-100">
          <div className="col-md-6 d-md-block d-none h-100 login-image">
            <img className="banner" alt="" src={banner} />
          </div>
          <div className="col-md-6  login-content text-center">
            <div className="content-main h-100 px-5  d-flex flex-column justify-content-center">
              <div>
                <img
                  className="content-main-logo img-fluid"
                  alt=""
                  src={logo}
                />
              </div>
              <div className="py-2">
                <img
                  className="content-main-logo img-fluid"
                  alt=""
                  src={Error}
                />
              </div>
              <h2 className="text-white">Login Error</h2>
              <p className="text-white" style={{ fontWeight: "600" }}>
                {errorMessage}
              </p>
              <Link className="text-text-decoration-none" to="/">
                <button className="btn login-btn w-100 px-3 py-2 mt-3">
                  Try Again
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
